import CommonImage from 'common/components/entities/ImageNew'
import { PageTypeEnum } from 'common/enums/PageTypeEnum'
import { ImageInterface } from 'common/types/entities/ImageInterface'
import { isOldIOS } from 'common/utils/deviceDetection'
import { showPopup } from 'publisher/actionsManagement'
import StyleWrapper from 'publisher/components/core/StyleWrapper'
import React from 'react'
import { useDispatch } from 'react-redux'
import { useRemoveUnavailablePopups } from 'src/publisher/hooks/use-remove-unavailable-popups'
import { getImageSourceResult } from 'src/shared/utils/get-image-sources'
import { useDelay } from '../../hooks/useDelay'
import usePage from '../../hooks/usePage'
import { useFiles } from '../../store'
import { fileSelectors } from '../../store/file/fileSelectors'
import pageSelectors from '../../store/page/pageSelectors'

function renderImage(
  entity: ImageInterface,
  src: string,
  loading: 'lazy' | 'eager',
  mobileSrc?: string,
  pointer = false,
  onClick?: (e: React.SyntheticEvent) => void,
) {
  return (
    <CommonImage
      attrId={entity.htmlAttrId}
      src={src}
      mobileSrc={mobileSrc}
      alt={entity.alt}
      alignSelf={entity.alignSelf}
      mobileAlignSelf={entity.mobileAlignSelf}
      boxShadow={entity.boxShadow}
      mobileBoxShadow={entity.mobileBoxShadow}
      border={entity.border}
      mobileBorder={entity.mobileBorder}
      background={entity.background}
      mobileBackground={entity.mobileBackground}
      delay={entity.delay}
      blur={entity.blur}
      ratio={entity.ratio}
      mobileRatio={entity.mobileRatio}
      width={entity.width}
      mobileWidth={entity.mobileWidth}
      onClick={onClick}
      pointer={pointer}
      loading={isOldIOS() ? undefined : loading}
      link={entity.link}
      openNewTab={entity.openNewTab}
    />
  )
}

function Image({ entity }: { entity: ImageInterface }) {
  const dispatch = useDispatch()
  const isVisible = useDelay(entity.delay)
  const pageType = usePage(pageSelectors.getPageType)
  const file = useFiles(files => fileSelectors.getFile(files, entity.fileId))
  const mobileFile = useFiles(files =>
    fileSelectors.getFile(files, entity.mobileFileId),
  )
  const loading = [PageTypeEnum.Popup, PageTypeEnum.Inline].includes(pageType)
    ? 'eager'
    : 'lazy'

  useRemoveUnavailablePopups({ entity })

  const { imageSrc, mobileImageSrc } = getImageSourceResult({
    entity,
    desktopFilePath: file?.path,
    mobileFilePath: mobileFile?.path,
  })

  if (!imageSrc) {
    return <div />
  }

  const image = entity.popupId
    ? renderImage(entity, imageSrc, loading, mobileImageSrc, true, () =>
        dispatch(showPopup(entity.popupId)),
      )
    : renderImage(entity, imageSrc, loading, mobileImageSrc)

  return isVisible ? (
    <StyleWrapper
      margin={entity.margin}
      mobileMargin={entity.mobileMargin}
      appearance={entity.appearance}
      flex
      flexColumn
    >
      {image}
    </StyleWrapper>
  ) : (
    <div />
  )
}

export default Image
